import { ManuscriptsTableConfig } from "./edit-manuscripts.objects";
import { ManuscriptsTable } from "./edit-manuscripts.table";

export class EditManuscriptsPage {
    manuscriptsTableConfig!: ManuscriptsTableConfig;
    manuscriptsTable?: ManuscriptsTable;

    private inited = false;
  
    constructor() { }

    initEditPane(): void {
        if (this.inited) return;
        this.inited = true;
       

        this.manuscriptsTableConfig = {
            getManuscriptsRoute: "/secure/edit-manuscripts?handler=Manuscripts",
            getEditableManuscriptIdsRoute: "/secure/edit-manuscripts?handler=EditableManuscriptIds",

            tableContainerId: "edit-ms-manuscripts-content",
            loadingContainerId: "edit-ms-loading-content-container",
            loadedContentId: "edit-ms-loaded-manuscripts-content",

            isEditable: true,
            tableVarName: "manuscriptsTable",
            isAdmin: false,

            editModalId: "edit-ms-modal",
            postRoute: "/secure/edit-manuscripts?handler=SaveManuscripts",
            addModalId: "add-new-modal",
            additionalInfoModalId: "filterDefsModal"
          
        };

        this.manuscriptsTable = new ManuscriptsTable(this.manuscriptsTableConfig);
    }

    closeAllModals(): void {
        $(".modal").modal("hide");
    }
}
